var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game"},[_c('div',{attrs:{"id":"game-wrapper"}},[(_vm.downloaded)?_c('phaser-canvas'):_vm._e(),_c('HUD',{ref:"hud"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }